
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interactive-videos/[activitySlug]",
      function () {
        return require("private-next-pages/interactive-videos/[activitySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interactive-videos/[activitySlug]"])
      });
    }
  